module.exports = __webpack_public_path__ + "img/view_device_c6s_en.8f858817.png";